import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../index.css";
import { billpunchbasicauth } from "../../utils/Credentials";
import { GlobalContext } from "../../Context/GlobalState";
import swal from "sweetalert";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

import "../../index.css";
import { LoanTable, MyLoanTable } from "./Table";
import { LoanModal } from "./Modal";
const Loanmanagementemployee = () => {
  const { password, username } = billpunchbasicauth;
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [showModal, setShowModal] = useState(false);
  const [loanList, setLoanList] = useState([]);
  const [myloanList, setMyloanList] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [loanTypes, setLoanTypes] = useState([]);
  const [loanData, setLoanData] = useState({
    loan_disbursement_date: "",
    loan_file_charge: "",
    loan_emi_amount: "",
    emi_tenure: "",
    start_date: "",
    end_date: "",
    is_active: 1,
    total_loan: 0,
    loan_type: "",
    remark: "",
  });

  const today = new Date().toISOString().split("T")[0];
  const handleChange = (e) => {
    const { name, value } = e.target;

    setLoanData((prev) => {
      const updatedData = { ...prev };

      if (name === "start_date") {
        updatedData.start_date = value ? value + "-01" : "";

        if (updatedData.emi_tenure > 0 && updatedData.start_date) {
          const start = new Date(updatedData.start_date);
          start.setMonth(start.getMonth() + updatedData.emi_tenure);
          updatedData.end_date = start.toISOString().split("T")[0];
        } else {
          updatedData.end_date = "";
        }
      } else {
        updatedData[name] = value;

        const totalLoan = Number(updatedData.total_loan);
        const emiAmount = Number(updatedData.loan_emi_amount);

        if (totalLoan > 0 && emiAmount > 0) {
          updatedData.emi_tenure = Math.ceil(totalLoan / emiAmount);

          if (updatedData.start_date) {
            const start = new Date(updatedData.start_date);
            start.setMonth(start.getMonth() + updatedData.emi_tenure);
            updatedData.end_date = start.toISOString().split("T")[0];
          }
        } else {
          updatedData.emi_tenure = 0;
          updatedData.end_date = "";
        }
      }

      return updatedData;
    });
  };
  const Getloan = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        firm_id: user.firm_id,
        empid: user.userid,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Getloan`,
        requestOptions
      );

      const data = await res.json();

      if (data.status === "0") {
        setLoanList(data.data);
      } else {
        setLoanList([]);
      }
    } catch (error) {
      console.log("error", error);
    }

    setTransactionLoaderState(false);
  };
  const getApprovedLoanDetails = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        firmid: user.firm_id,
        empid: user.userid,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/v2.0/getApprovedLoanDetails`,
        requestOptions
      );

      const data = await res.json();

      if (data.responseCode === "00") {
        setMyloanList(data.response || []);
      } else {
        setMyloanList([]);
      }
    } catch (error) {
      console.log("error", error);
    }

    setTransactionLoaderState(false);
  };
  const GetLoanTypes = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({});

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Getloantypemaster`,
        requestOptions
      );

      const data = await res.json();

      if (data.status === "0") {
        setLoanTypes(data.data);
      } else {
        setLoanTypes([]);
      }
    } catch (error) {
      console.log("error", error);
    }

    setTransactionLoaderState(false);
  };
  const handleSubmit = async () => {
    setTransactionLoaderState(true);

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        empid: user.userid,
        loan_disbursement_date: loanData.loan_disbursement_date,
        loan_file_charge: 0,
        loan_emi_amount: Number(loanData.loan_emi_amount),
        emi_tenure: Number(loanData.emi_tenure),
        start_date: loanData.start_date,
        end_date: loanData.end_date,
        in_date: today,
        is_active: Number(loanData.is_active),
        total_loan: Number(loanData.total_loan),
        firmid: user.firm_id,
        loan_type: loanData.loan_type,
        remark: loanData.remark,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Insertloandata`,
        requestOptions
      );

      const data = await res.json();

      if (data.status === "0") {
        swal("Success", data.result, "success");
        setShowModal(false);
        Getloan();
        setLoanData({
          loan_disbursement_date: "",
          loan_file_charge: "",
          loan_emi_amount: "",
          emi_tenure: "",
          start_date: "",
          end_date: "",
          in_date: "",
          is_active: 1,
        });
      } else {
        swal("Error", data.msg, "error");
      }
    } catch (error) {
      console.log(error);
      swal("Error", "Something went wrong", "error");
    }

    setTransactionLoaderState(false);
  };
  useEffect(() => {
    Getloan();
    GetLoanTypes();
    getApprovedLoanDetails();
  }, []);

  return (
    <>
      <div className="mt-4 m-3">
        <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
          <h5 className="m-0">Manage loan</h5>

          <div className="d-flex gap-2">
            <button
              className="btn btn-success btn-sm"
              onClick={() => setShowModal(true)}
              style={{ borderRadius: "6px", padding: "4px 14px" }}
            >
              + Apply Loan
            </button>
          </div>
        </div>
        <ul className="nav nav-tabs mb-3 d-flex">
          {[
            {
              key: "all",
              label: "All Loans",
              color: "#f8d7da",
              text: "#721c24",
            },
            { key: "my", label: "My Loan", color: "#fff3cd", text: "#856404" },
            {
              key: "history",
              label: "Loan History",
              color: "#d4edda",
              text: "#155724",
            },
          ].map((tab) => (
            <li key={tab.key} className="nav-item flex-fill text-center">
              <span
                className="nav-link"
                onClick={() => setActiveTab(tab.key)}
                style={{
                  cursor: "pointer",
                  backgroundColor: activeTab === tab.key ? "#0d6efd" : "",
                  color: activeTab === tab.key ? "#fff" : tab.text,
                  border: "1px solid #dee2e6",
                  borderBottom:
                    activeTab === tab.key ? "3px solid #0d6efd" : "none",
                  fontWeight: activeTab === tab.key ? 600 : 400,
                  transition: "background-color 0.3s",
                }}
              >
                {tab.label}
              </span>
            </li>
          ))}
        </ul>

        <div
          style={{
            minHeight: "300px",
            padding: "10px",
            border: "1px solid #dee2e6",
            borderRadius: "6px",
          }}
        >
          {activeTab === "my" && <MyLoanTable myloanList={myloanList} />}
          {activeTab === "history" && <div>Loan history records </div>}
          {activeTab === "all" && <LoanTable loanList={loanList} />}
        </div>

        <LoanModal
          showModal={showModal}
          setShowModal={setShowModal}
          loanData={loanData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          loanTypes={loanTypes}
        />
      </div>
    </>
  );
};

export default Loanmanagementemployee;
